var _path, _path2, _path3, _path4, _path5;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCategory5(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.2798 27.5996C11.754 27.5996 13.7598 25.5939 13.7598 23.1196C13.7598 20.6454 11.754 18.6396 9.2798 18.6396C6.80557 18.6396 4.7998 20.6454 4.7998 23.1196C4.7998 25.5939 6.80557 27.5996 9.2798 27.5996Z",
    stroke: "#00A372",
    strokeWidth: 1.7,
    strokeMiterlimit: 10
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M25.7998 13.5998H18.5998C18.1198 13.5998 17.7998 13.2798 17.7998 12.7998V5.5998C17.7998 5.1198 18.1198 4.7998 18.5998 4.7998H25.7998C26.2798 4.7998 26.5998 5.1198 26.5998 5.5998V12.7998C26.5998 13.2798 26.2798 13.5998 25.7998 13.5998Z",
    stroke: "#00A372",
    strokeWidth: 1.7,
    strokeMiterlimit: 10
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M25.7997 27.5997C25.6397 27.5997 25.4797 27.5997 25.3197 27.4397L17.9597 20.0797C17.6397 19.7597 17.6397 19.2797 17.9597 18.9597C18.2797 18.6397 18.7597 18.6397 19.0797 18.9597L26.4397 26.3197C26.7597 26.6397 26.7597 27.1197 26.4397 27.4397C26.2797 27.5997 26.1197 27.5997 25.7997 27.5997Z",
    fill: "#00A372"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M18.4396 27.5997C18.5996 27.5997 18.7596 27.5997 18.9196 27.4397L26.2796 20.0797C26.5996 19.7597 26.5996 19.2797 26.2796 18.9597C25.9596 18.6397 25.4796 18.6397 25.1596 18.9597L17.7996 26.3197C17.4796 26.6397 17.4796 27.1197 17.7996 27.4397C18.1196 27.5997 18.2796 27.5997 18.4396 27.5997Z",
    fill: "#00A372"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M12.96 13.5999H5.59999C4.95999 13.5999 4.63999 13.1199 4.79999 12.6399L8.47999 5.27992C8.79999 4.79992 9.59999 4.79992 9.75999 5.27992L13.44 12.6399C13.76 13.1199 13.44 13.5999 12.96 13.5999Z",
    stroke: "#00A372",
    strokeWidth: 1.7,
    strokeMiterlimit: 10
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCategory5);
export default __webpack_public_path__ + "static/media/category5.fe6d0ad9eac191732ded4b1303548d07.svg";
export { ForwardRef as ReactComponent };